import { useState, useEffect, useRef, useCallback } from 'react';
import { startsWith } from 'lodash';
import { on, off, isElementInViewport } from '@sparefoot/react-core/utils/dom';

const TRANSPARENT_GIF =
	'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export { TRANSPARENT_GIF };

export default function useLazyLoad(originalSrc, lazyLoad) {
	const [isVisible, setIsVisible] = useState(
		startsWith(originalSrc, 'data:image') || !lazyLoad,
	);
	const instanceRef = useRef(null);
	const isVisibleRef = useRef(isVisible);

	const getRef = useCallback((el) => {
		instanceRef.current = el;
	}, []);

	const handleViewportChange = useCallback(() => {
		if (!isVisibleRef.current && instanceRef.current) {
			const visible = isElementInViewport(instanceRef.current);
			if (visible) {
				setIsVisible(true);
				isVisibleRef.current = true;
			}
		}
	}, []);

	useEffect(() => {
		if (lazyLoad && !isVisibleRef.current) {
			on(['scroll', 'resize'], handleViewportChange);
			handleViewportChange();
		}
		return () => {
			off(['scroll', 'resize'], handleViewportChange);
		};
	}, [lazyLoad, handleViewportChange]);

	useEffect(() => {
		if (isVisible) {
			off(['scroll', 'resize'], handleViewportChange);
		}
	}, [isVisible, handleViewportChange]);

	const displaySrc = isVisible ? originalSrc : TRANSPARENT_GIF;

	return { displaySrc, getRef, isVisible };
}
